export default "__VITE_ASSET__c8df5f00__"